export const header = 'Escanea un QR Volbi';
export const noQR = 'No se ha identificado ningún código QR aún. También puedes escanear '
+ 'directamente desde tu cámara.';
